import React from 'react';
import { StarIcon } from 'lucide-react';
import { Section, Eyebrow, Heading } from '../Section';
import { CTAButton } from '../CTAButton';
import { testimonials } from '../../data/testimonials';
export function Testimonials() {
  return <Section tone="dark" data-id="element-276" data-mp="3mf7rekblhudm">
      <Eyebrow data-id="element-277" data-mp="3mez9uf4j20w3">⭐ Real results</Eyebrow>
      <Heading data-id="element-278" data-mp="3r7sel2zzx986">What other technicians are saying</Heading>

      <div className="mt-8 space-y-4" data-id="element-279" data-mp="3r9byr4orw4f8">
        {testimonials.map(testimonial => <figure key={testimonial.name} className="rounded-2xl border border-white/10 bg-navy-950 p-5" data-id="element-280" data-mp="3aimhpyakmq">
            <div className="flex items-center gap-3" data-id="element-281" data-mp="91e5bhco9ng4">
              <img src={testimonial.photo} alt={testimonial.name} className="h-14 w-14 shrink-0 rounded-full object-cover ring-2 ring-gold-500" loading="lazy" data-id="element-282" data-mp="8zt8tm6srufm" />
              <figcaption data-id="element-283" data-mp="2fru18mxsc115">
                <p className="font-display text-lg font-bold uppercase leading-tight text-white" data-id="element-284" data-mp="2fteywlfec038">
                  {testimonial.name}
                </p>
                <p className="text-[12px] font-semibold uppercase tracking-wide text-gold-400" data-id="element-285" data-mp="1ntt0b3cy14sd">
                  {testimonial.country}
                </p>
              </figcaption>
            </div>

            <div className="mt-3 flex gap-0.5" aria-label="Rated 5 out of 5 stars" data-id="element-286" data-mp="1et4lw7jn12ey">
              {Array.from({
            length: 5
          }).map((_, index) => <StarIcon key={index} className="h-4 w-4 fill-gold-500 text-gold-500" aria-hidden="true" data-id="element-287" data-mp="2bh12hcf2rxq6" data-mpi={index} />)}
            </div>

            <blockquote className="mt-3 text-[15px] leading-relaxed text-white/85 sm:text-base" data-id="element-288" data-mp="1xjm6foubgrp8">
              “{testimonial.quote}”
            </blockquote>
          </figure>)}
      </div>

      <div className="mt-8" data-id="element-289" data-mp="m4gtzt4dvesf">
        <CTAButton label="I want results like these" data-id="element-290" data-mp="m47amodug5vp" />
      </div>
    </Section>;
}